<div class="eventContainer {{ (calenderEvent.priority === 'high' ? 'danger' : calenderEvent.priority === 'low' ? 'success' : 'warning') }}">
  <div class="d-flex justify-content-between align-items-center mb-1 mt-3">
    <div class="event-details flex-grow-1 d-flex">
      <div class="event-bar"></div>
      <div class="ms-2">
        <app-headline [title]="((calendarStore.translate() && calenderEvent.name_translated !== null) ? calenderEvent.name_translated : calenderEvent.name) ?? ''" [type]="'h6'" [class]="'fw-bold mb-1 event-title truncate-text-one-line'"></app-headline>
        <div class="mb-0 lh-1">
          <app-content 
            [fontSize]="'fs-verysmall'" 
            [fontColor]="'text-muted'" 
            [class]="'truncate-text-four-lines'"
          >
            {{ 
              (getPlainTextPreview(
          (calendarStore.translate() && calenderEvent.description_translated !== null) ?
                  calenderEvent.description_translated :
                  calenderEvent.description)
                )
            }}
          </app-content>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center">
    <div class="d-flex flex-grow-1">
      <app-form-button 
        [style]="'btn'" 
        [text]="(displayStartAt | date : 'short') ?? ''" 
        [cssClass]="'btn-flat text-muted fs-verysmall cursor-default p-0'" 
        [icon]="'schedule'" 
        [iconPosition]="'left'">
      </app-form-button>
      @if(!isMaskedEvent()){
        <app-form-button 
          (click)="this.details.emit(this.calenderEvent);"
          [style]="'btn'" 
          [text]="('CALDETAILS' | translate)" 
          [cssClass]="'btn-link text-primary fs-verysmall px-1 py-0'" 
          [iconClass]="'text-primary'" 
          [icon]="'description'" 
          [iconPosition]="'left'">
        </app-form-button>
      }
    </div>

    @if(calenderEvent.permission.editable){
      <div class="justify-content-end">
        <div class="dropdown">
          <button class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
            <app-icon-badge [style]="'notification'" [icon]="'more_horiz'" [screenReaderText]="'SRMOREOPTIONS' | translate"></app-icon-badge>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li><app-link (click)="showEditTypeOverlay()" [title]="('CALEDITEVENT' | translate)" [style]="'dropdown'">{{ ('CALEDITEVENT' | translate) }}</app-link></li>
            <li><app-link (click)="showDeleteTypeOverlay()" [title]="('CALDELETEEVENT' | translate)" [style]="'dropdown'">{{ ('CALDELETEEVENT' | translate) }}</app-link></li>
          </ul>
        </div>
      </div>
    }
  </div>
</div>

@if(deleteTypeDialogVisible){
  <ejs-dialog 
    #deleteTypeDialog 
    [showCloseIcon]='true'
    [animationSettings]="dialogService.getAnimationSettings()"
    [resizeHandles]="dialogService.getResizeHandleDirection()"
    [position]="dialogService.getPosition()"
    [isModal]="true"
    [allowDragging]="false"
    [width]="'30%'"
    [height]="'auto'"
    [zIndex]="999"
    [showCloseIcon]="false"
    >
      <ng-template #header class="p-1">
        <app-headline [title]="'CALDELEVENTTYPE' | translate" [type]="'h5'"></app-headline>
      </ng-template>
      <ng-template #content>
        <div class="d-flex p-2">
          <!-- Do you want to delete only this occurrence or the entire series?-->
          <app-content
            [fontSize]="'fs-default'"
            [fontColor]="'text-muted'"
            >{{ 'DELETEOCCURRENCEORSERIESQUESTION' | translate }}</app-content
          >
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center gap-2 w-100 p-2">
          <app-form-button
            [text]="'DELETEOCCURRENCE' | translate"
            (click)="showDeleteOverlay(true)"
            [cssClass]="'e-primary'"
          ></app-form-button>
          <app-form-button
            [text]="'DELETESERIES' | translate"
            (click)="showDeleteOverlay(false)"
            [cssClass]="'e-outline mx-1'"
          ></app-form-button>
          <app-form-button
            [text]="'CANCEL' | translate"
            (click)="deleteTypeDialogVisible = false"
            [cssClass]="'e-link'"
          ></app-form-button>
        </div>
      </ng-template>
  </ejs-dialog>
}

@if(editTypeDialogVisible){
  <ejs-dialog 
    #editTypeDialog 
    [showCloseIcon]='true'
    [animationSettings]="dialogService.getAnimationSettings()"
    [resizeHandles]="dialogService.getResizeHandleDirection()"
    [position]="dialogService.getPosition()"
    [isModal]="true"
    [allowDragging]="false"
    [width]="'30%'"
    [height]="'auto'"
    [zIndex]="999"
    [showCloseIcon]="false"
    >
      <ng-template #header class="p-1">
        <app-headline [title]="'CALEDITEVENTTYPE' | translate" [type]="'h5'"></app-headline>
      </ng-template>
      <ng-template #content>
        <div class="d-flex p-2">
          <!-- Do you want to delete only this occurrence or the entire series?-->
          <app-content
            [fontSize]="'fs-default'"
            [fontColor]="'text-muted'"
            >{{ 'EDITOCCURRENCEORSERIESQUESTION' | translate }}</app-content
          >
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center gap-2 w-100 p-2">
          <app-form-button
            [text]="'EDITOCCURRENCE' | translate"
            (click)="editEvent(true)"
            [cssClass]="'e-primary'"
          ></app-form-button>
          <app-form-button
            [text]="'EDITSERIES' | translate"
            (click)="editEvent(false)"
            [cssClass]="'e-outline mx-1'"
          ></app-form-button>
          <app-form-button
            [text]="'CANCEL' | translate"
            (click)="editTypeDialogVisible = false"
            [cssClass]="'e-link'"
          ></app-form-button>
        </div>
      </ng-template>
  </ejs-dialog>
}
